var _ = require('underscore');
var $ = require('jquery');
var Marionette = require('marionette');
var Authorization = require('Authorization');
var Behaviors = require('Behaviors');
var consultation = require('Consultation');
var Dialog = require('Dialog');
var Entities = require('Entities');
var ExportAggregate = [
    { $unwind: { path: "$roles", preserveNullAndEmptyArrays: true } },
    { $project: { active: 1, adStatus: 1, displayName: 1, email: 1, geography: 1, givenName: 1, gpn: 1, id: 1, modifiedBy: 1, modifiedOn: 1, physicalDeliveryOfficeName: 1, preferences: 1, privacyAck: 1, privacyAckDate: 1, privacyAckVersion: 1, roles: "$roles", status: 1, upn: 1, _id: 1 } },
    { $unionWith: {
            coll: "user",
            pipeline: [
                { $unwind: { path: "$deletedRoles", preserveNullAndEmptyArrays: true } },
                { $project: { active: 1, adStatus: 1, displayName: 1, email: 1, geography: 1, givenName: 1, gpn: 1, id: 1, modifiedBy: 1, modifiedOn: 1, physicalDeliveryOfficeName: 1, preferences: 1, privacyAck: 1, privacyAckDate: 1, privacyAckVersion: 1, roles: "$deletedRoles", status: 1, upn: 1, _id: 1 } }
            ]
        }
    },
    { $sort: { _id: 1 } }
]

var ExportNode = require('ExportNode');
var Filters = require('UserFilters');
var DeactivateUsers = require('DeactivateUsers');
var Grid = require('Grid');
var Pagination = require('Pagination');
var Profile = require('UserProfile');
var RecordPurge = require('RecordPurge');
var Router = require('Router');
var UserLookup = require('UserLookup');
var Labels = EY.Consultation.Labels;
var Roles = _.sortBy(EY.Consultation.Resources.Roles, 'order').filter(function(role){ return !["RecordPurgeAdministrator", "SupportAdministrator"].includes(role._id) });
var Resources = EY.Consultation.Resources;
var Geographies = new Entities.Geographies(Resources.Geography);
var ExportQuery = new Entities.Queries([{ aggregate: ExportAggregate, selected: true }]);
var Queries = new Entities.Queries([{id: '', filter: { roles: { $exists: true, $ne: []}}, select: {}, selected: true }]);

var navigate = function (id) {
    Router.navigate("Administration/UserProfile/" + id, { trigger: true });
};

var Action = Marionette.View.extend({
    className: 'string-cell sortable renderable id',
    events: {
        'click @ui.id': 'navigate'
    },
    tagName: 'td',
    template: '#manageUsersGridAction',
    ui: {
        id: '#id'
    },
    navigate: function () {
        navigate(this.model.id);
    }
});

var Tooltip = Marionette.View.extend({
    behaviors: [Behaviors.TooltipGrid],
    className: 'string-cell sortable renderable visible-lg visible-md visible-sm tooltip-css',
    tagName: 'td',
    template: _.noop
});

var columns = function () {
    return [{ name: 'givenName', label: Labels.UserName, editable: false, cell: Action },
    { name: 'email', label: Labels.Email, editable: false, cell: 'string' }, { name: 'gpn', label: Labels.GPN, editable: false, cell: Tooltip }].concat(_.map(Roles, function (role) {
        return { name: role.id, label: Labels['Role_' + role.id + '_SN'], editable: false, cell: 'string', sortable: false };
    })).concat([{ name: 'active', label: Labels.Status, editable: false, cell: 'string' }]);
};

var exportColumns = function () {
    return [{name: 'givenName', label: Labels.UserName, editable: false, cell: 'string', columnWidth: 'L'},
        {name: 'email', label: Labels.Email, editable: false, cell: 'string', columnWidth: 'L'},
        {name: 'gpn', label: Labels.GPN, editable: false, cell: 'string', columnWidth: 'M'},
        {name: 'roleId', label: Labels.Role, editable: false, cell: 'string', columnWidth: 'L'},
        {name: 'area', label: Labels.Area, editable: false, cell: 'string', columnWidth: 'M'},
        {name: 'region', label: Labels.Region, editable: false, cell: 'string', columnWidth: 'M'},
        {name: 'country', label: Labels.Country, editable: false, cell: 'string', columnWidth: 'M'},
        {name: 'subregion', label: Labels.SubRegion, editable: false, cell: 'string', columnWidth: 'M'},
        {name: 'specialty', label: Labels.Specialty, editable: false, cell: 'string', columnWidth: 'M'},
        {name: 'status', label: Labels.Status, editable: false, cell: 'string', columnWidth: 'S'},
        {name: 'adStatus', label: Labels.AdStatus, editable: false, cell: 'string', columnWidth: 'S'},
        {name: 'modifiedOn', label: Labels.ModifiedOn, editable: false, cell: 'string', columnWidth: 'L'},
        {name: 'modifiedBy', label: Labels.ModifiedBy, editable: false, cell: 'string', columnWidth: 'L'},
        {name: 'roleStatus', label: Labels.RoleStatus, editable: false, cell: 'string', columnWidth: 'S'}
    ];
};

var exportFields = function () {
    return [{value: 'givenName', label: Labels.UserName},
        {value: 'email', label: Labels.Email},
        {value: 'gpn', label: Labels.GPN},
        {value: 'roleId', label: Labels.Role},
        {value: 'area', label: Labels.Area},
        {value: 'region', label: Labels.Region},
        {value: 'country', label: Labels.Country},
        {value: 'subregion', label: Labels.SubRegion},
        {value: 'specialty', label: Labels.Specialty},
        {value: 'status', label: Labels.Status},
        {value: 'adStatus', label: Labels.AdStatus},
        {value: 'modifiedOn', label: Labels.ModifiedOn},
        {value: 'modifiedBy', label: Labels.ModifiedBy},
        {value: 'roleStatus', label: Labels.RoleStatus}
    ];
};
var geograhyText = function (geography, index, path, type) {
    return type.indexOf(geography) > 0 ? Geographies.get('/' + _.take(index, path.indexOf(geography) + 1).join('/') + '/').get('text') : '';
};

var exportFormat = function (users) {
    users.on('sync', function () {
        users.each(function (u) {
            var role = u.get('roles');
            if (role) {
                var index = role.geographyId.slice(1, -1).split('/');
                var path = role.geographyTypePath.slice(1, -1).split('/');
                var type = role.geographyTypePath;
                var modifiedOn = role.modifiedOn || '';
                var modifiedBy = role.modifiedBy || '';
                var roleStatus = role.status || '';
                u.set('area', geograhyText('Area', index, path, type));
                u.set('region', geograhyText('Region', index, path, type));
                u.set('country', geograhyText('Country', index, path, type));
                u.set('subregion', geograhyText('SubCountry', index, path, type));
                u.set('roleId', Labels['Role_' + role.roleId]);
                u.set('specialty', _.unescape(role.specialty));
                u.set('modifiedOn', !!modifiedOn ? modifiedOn : '');
                u.set('modifiedBy', modifiedBy);
                u.set('roleStatus', roleStatus);
            }
            u.set('status', u.get('active') ? Labels.Active : Labels.Inactive);
            u.set('adStatus', u.get('adStatus') === false ? Labels.Inactive : Labels.Active);
        });
    });
    return users;
};

var format = function (users) {
    users.on('sync', function () {
        users.each(function (u) {
            if (u.get('active')) {
                _.each(u.get('roles'), function (role) {
                    u.set(role.roleId, 'X');
                });
            }
            u.set('active', u.get('active') ? Labels.Active : Labels.Inactive);
        });
    });
    return users;
};

var fetchRolesText = function(roles) {
    return _.map(roles, function(role) {
        return Labels['Role_' + role];
    });
};

var fetchRegionText = function(regions) {
    return _.map(regions, function(region) {
        var index = region.slice(1, -1).split('/');
        var geography = index.length == 3 ? "Region/" : "SubCountry"
        var path = (index.length == 3 ? "/Area/Region/Country/" : "/Area/Region/Country/SubCountry/").slice(1, -1).split('/');
        var type = index.length == 3 ? "/Area/Region/Country/" : "/Area/Region/Country/SubCountry/";
        return geograhyText(geography, index, path, type);
    })
}

var Confirmation = Marionette.View.extend({
    template: '#exportConfirmation'
});

var Layout = Marionette.View.extend({
    behaviors: [{ behaviorClass: Authorization.RBAC, viewName: 'user' }],
    events: {
        'click @ui.add': 'add',
        'click @ui.export': 'export',
        'click #deactivate': 'deactivate',
        'click #purge': 'purge'
    },
    regions: {
        grid: '#manageUsersGrid',
        filters: '#filters',
        pager: '#pager',
        user: '#user'
    },
    template: '#manageUsers',
    ui: {
        add: '#add',
        'export': '#export',
        grid: '#manageUsersGrid'
    },
    add: function () {
        var model = this.model;
        var upn = model.get('upn');

        if (upn) {
            model.set({ _id: upn, id: upn }).fetch().done(function (found) {
                Profile.start({ user: found ? model : model.unset('id') });
            });
        }
    },
    'export': function () {
        var collection = exportFormat(new Entities.ExportUsers());
        var selectedQuery = ExportQuery.findWhere({ selected: true }) || ExportQuery.get('');

        //After implementing filtering logic on User Management page
        //we should export on the basis of applied filter

        //Get applied filter
        var filterQuery = Queries.findWhere({selected: true}) || Queries.get('');

        //Update export query to add applied filter by appending aggregate from filterQuery
        selectedQuery.set('aggregate', _.union(filterQuery.get('aggregate'), ExportAggregate));
        //selectedQuery.attributes.aggregate.push(filterQuery.get('aggregate')[0])

        var handleFileDownload = EY.Consultation.Lookups.Configuration.EnableXlsxDownload ? $.Deferred().resolve() : Dialog.show({
            saveLabel: Labels.OK,
            headerLabel: Labels.DialogTitleInformational,
            view: new Confirmation({
                model: new Backbone.Model({ message: Labels.MSG036 })
            })
        });

        handleFileDownload.done(function () {
            //Export.run({ collection: exportFormat(new Entities.ExportUsers()), fields: exportFields(), columns: exportColumns(), fileName: Labels.ExportUsersFileName, queries: ExportQuery });
            $('html,body').addClass('wait-cursor');

            var options = _.pick(selectedQuery.attributes, ['aggregate', 'filter', 'select']);
            options.error = function() {
                $('html,body').removeClass('wait-cursor');
                consultation.showToast({
                    result: "danger",
                    text: Labels.ExportWarningMessage
                });
            };
            collection.fetch(options).done(function () {
                var usersWithRoles = collection.filter(function(user) {
                    var roles = user.get('roles');
                    return !!roles && !!roles.roleId;
                });

                usersWithRoles = _.uniq(usersWithRoles, function (user) {
                    return user.get('active') ? user.cid : user.get('id');
                });

                var filteredGeos = filterQuery.get('filteredGeos') || [];
                var filteredRoles = filterQuery.get('filteredRoles') || [];
                var isFilteredGeos = filteredGeos.length;
                var isFilteredRoles = filteredRoles.length;
                var isAggregate =  filterQuery.get('aggregate').length || false;
                if (isAggregate && (isFilteredGeos || isFilteredRoles)) {
                    usersWithRoles = usersWithRoles.filter(function(user) {
                        var roles = user.get('roles');
                        return (isFilteredGeos && isFilteredRoles) ? 
                            (!!roles.geographyId && filteredGeos.includes(roles.geographyId) && 
                            !!roles.roleId && filteredRoles.includes(roles.roleId)) : 
                            (isFilteredGeos && filteredGeos.includes(roles.geographyId) || 
                            isFilteredRoles && filteredRoles.includes(roles.roleId));
                    });
                }
                var userRoleCount = filterQuery.get('count');
                var countOfDistinctUsers = Labels.CountOfDistinctUsers+" = "+userRoleCount;
                var countOfRows = Labels.CountOfRows+" = "+(usersWithRoles.length || 0);
                var appliedRegionFilter = Labels.AppliedRegionFilter+" = "+((isFilteredGeos && isAggregate) ? fetchRegionText(filteredGeos).toString() : '" "');
                var appliedRoleFilter = Labels.AppliedRoleFilter+" = "+((isFilteredRoles && isAggregate) ? fetchRolesText(filteredRoles).toString() : '" "');
                
                var filteredCollection = new Entities.ExportUsers(usersWithRoles);
                filteredCollection.each(function (user) {
                    !user.get('active') && user.set({
                        area: '',
                        region: '',
                        country: '',
                        subregion: '',
                        roleId: '',
                        roles: [],
                        geography: ''
                    });
                });
                // Below changes is to show user count and applied filters in the last row of the export file
                filteredCollection.push({ 'givenName': countOfDistinctUsers, 'email': countOfRows, 'gpn': appliedRegionFilter, 'roleId': appliedRoleFilter });
                ExportNode.send({ collection: filteredCollection, fields: exportFields(), columns: exportColumns(), fileName: Labels.ExportUsersFileName, queries: ExportQuery });
                $('html,body').removeClass('wait-cursor');
            }).fail(function () {
                $('html,body').removeClass('wait-cursor');
            });
        });
    },
    'deactivate': function () {
        var deactivateUsers = new Entities.Users();
        var queries = this.options.queries || Queries;

        var options = {
            error: function() {
                consultation.showToast({
                    result: "danger",
                    text: Labels.ExportWarningMessage
                });
            }
        }
        deactivateUsers.fetch(options).done(function () {

            //If we deactivate all users in one go there are too many requests to process
            //and chrome throws errors (see US 143108). To reduce this, the method now
            //deactivates users in chunks.
            var chunkSize = 500;
            var chunks = Math.ceil(deactivateUsers.length / chunkSize) || 1;

            //This holds promises for all chunks and when all promises are done (all chunks are processed)
            //we show the final success message
            var deactivatePromises = [];

            //This function provides the chunked user data to DeactivateUsers and runs once for each chunk
            function deactivateSlice(users, deferred) {

                DeactivateUsers.run({ users: users }).done(function () {
                    deferred.resolve();
                });
            }

            //This wrapper function is needed to ensure that loop variables maintain their state.
            function callSetTimeout(startIndex, endIndex, deferred, i) {

                //Currently each chunk is triggered every 30 seconds.
                //TODO: make this time configurable.
                setTimeout(function () { deactivateSlice(deactivateUsers.slice(startIndex, endIndex), deferred); }, i * 30000);
            }

            for (i = 0; i < chunks; i++) {

                var startIndex = i * chunkSize;
                var endIndex = (i + 1) * chunkSize;
                var deferred = $.Deferred();
                var promise = deferred.promise();
                deactivatePromises.push(promise);

                callSetTimeout(startIndex, endIndex, deferred, i);
            }

            $.when.apply(this, deactivatePromises).done(function () {
                queries.first().set({ selected: false });
                queries.first().set({ selected: true });
                require('Consultation').showToast({ result: "success", text: Labels.UpdateStatusUpdateSuccessMessage });
            });
        });
    },
    'purge': function () {

        RecordPurge.run();
    }
});

module.exports.start = function () {
    var user = new Entities.User();
    var users = format(new Entities.Users());

    //Reset queries (clear any applied filters when user comes back to Admin page)
   Queries = new Entities.Queries([{ id: '', filter: { roles: { $exists: true, $ne: []}}, select: {}, selected: true }]);
    
    var layout = new Layout({
        collection: users,
        model: user
    });

    consultation.show({ view: layout });
    Filters.show({ queries: Queries, rows: users, region: layout.getRegion('filters') });
    Grid.show({
        collection: users,
        columns: columns(),
        region: layout.getRegion('grid')
    });
    UserLookup.show({
        region: layout.getRegion('user'),
        user: user
    });
    Pagination.show({ queries: Queries, rows: users, region: layout.getRegion('pager') });
};


// WEBPACK FOOTER //
// ./js/Modules/User/UserManagement.js